<template>
    <div class="wrap">
        <div class="content" id="content">
            <div class="con">
                <img v-for="index in 9" :src="'https://appd.knowbox.cn/ss/activity/parent_frontend/member/member-card/0'+index+'.png'" />
            </div>
        </div>

        <div class="button" v-if="!infoData.isPaid" @click="goPay"></div>
        <div class="button-paid" v-else @click="goShip"></div>
        <div class="left">{{infoData.giftStock}}</div>
    </div>
</template>

<script>
import ajax from "@/api/memberAjax.js";
import utils from "@/assets/js/utils";
import {isIOS, isAndroid} from "@/utils/env";
import {hideTitleBar} from '@/utils/hybird';

const token = utils.getQueryString('token');
const version = utils.getQueryString('version');
const source = utils.getQueryString('source');

var vm = null;
window.jsCallback = function(res) {
    if(res == 'cancel') {
        vm.showFailToast = true;
    }else {
        window.location.href = '/#/address?version=' + version + '&token=' + token + '&source=' + source
    }
    
}

export default {
    name: "",
    data() {
        return {
            infoData: {}
        }
    },

    methods: {
        async getInfo() {
            let resp = await ajax.get('/pay/return-money/homepage?timestamp=' + Date.now(), {
                params: { token, version, source }
            });
            if(resp.config) resp = resp.data;
            if(resp.code == 99999) {
                this.infoData = resp.data;
                
            } else {
                this.$toast(resp.msg);
            }
        },

        goPay() {
            const { productId, title, needUpgrade, freeDays } = this.infoData;
            let url = isIOS() ?
                    `hybird://method/openDirectPay?productId=${productId}&jsCallBack=jsCallback`:
                    `hybird://method/openDirectPay?productId=${productId}&jsCallBack=jsCallback&productName=${title}&comeFrom=${needUpgrade ? '113' : '112'}&paymentChannel=wx`;
            setTimeout(()=> {
                window.location.href = url;
            }, 100);
        },

        goShip() {
            this.$router.push({path: '/card/logistics?version=' + version + '&token=' + token + '&source=' + source});
        }
    },
    created() {
        vm = this;
    },
    mounted() {
        this.getInfo();
        hideTitleBar(0);
    }
}
</script>

<style lang="scss" scoped>
    .content {
        img {
            width: 100%;
            display: block;
        }
    }
    .button {
        background: url(https://appd.knowbox.cn/ss/activity/parent_frontend/member/member-card/btn.png) no-repeat;
        width: 7.5rem;
        height: 1.21rem;
        background-size: 100%;
        position: fixed;
        left: 0;
        bottom: 0;
    }

    .button-paid {
        background: url(https://appd.knowbox.cn/ss/activity/parent_frontend/member/member-card/btn-paid.png) no-repeat;
        width: 7.5rem;
        height: 1.21rem;
        background-size: 100%;
        position: fixed;
        left: 0;
        bottom: 0;
    }

    .left {
        position: absolute;
        width: .5rem;
        height: .3rem;
        line-height: .3rem;
        z-index: 10;
        top: 4.5rem;
        right: 1.67rem;
        color: red;
        font-size: .3rem;
        font-weight: bold;
        text-align: center;
    }
</style>